/* eslint-disable */
import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogContentText, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import { sessionState } from 'appConstants';

export default function AppDialog({
  open,
  handleMinimize,
  handleClose,
  handleCancel,
  handleEndChatConfirmation,
  handleResetChatSession,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { state } = useSelector((state) => state.appReducer);

  return (
    <Dialog fullScreen open={open} aria-describedby="dialog-description">
      <Header tabIndex="0" handleMinimize={handleMinimize} handleClose={handleClose} t={t} />
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '80%',
        }}
      >
        <DialogContentText
          id="dialog-description"
          style={{
            color: theme.palette.text.primary,
            fontFamily: 'Helvetica',
            fontSize: 14,
            marginBottom: 20,
          }}
        >
          {state === sessionState.FAILED
            ? t('jobchat_session_ended', 'Session has ended. Please start a new chat session.')
            : t('end_chat', 'Are you sure you want to end this chat?')}
        </DialogContentText>
        {state === sessionState.FAILED ? (
          <Button
            style={{ borderRadius: '25px', height: '43px', width: '15%' }}
            variant="contained"
            color="primary"
            onClick={handleResetChatSession}
          >
            {t('ok', 'OK')}
          </Button>
        ) : (
          <Box>
            <Button
              style={{ borderRadius: '25px', height: '43px', width: '15%' }}
              color="primary"
              onClick={handleCancel}
            >
              {t('no', 'NO')}
            </Button>
            <Button
              style={{ borderRadius: '25px', height: '43px', width: '15%' }}
              variant="contained"
              color="primary"
              onClick={handleEndChatConfirmation}
            >
              {t('yes', 'YES')}
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
